import type { ContactResponse } from 'types/contacts/contact-response';

const ARRAY_KEYS = [
  'contacts',
  'Contacts',
  'data',
  'Data',
  'items',
  'Items',
  'results',
  'Results',
  'rows',
  'Rows',
  'contactList',
  'ContactList',
] as const;

const TOTAL_KEYS = ['totalCount', 'total_count', 'TotalCount', 'total', 'Total', 'count', 'Count'] as const;

function readTotalCount(o: Record<string, unknown>): number | undefined {
  //* שרת הנוד (searchContacts) מחזיר את הסכום בתוך pagination.total — בלי הבדיקה הזו
  //* totalCount חזר תמיד undefined והרשימה לא ידעה כמה שורות יש בסך הכל.
  const pagination = o.pagination ?? o.Pagination;
  if (pagination && typeof pagination === 'object' && !Array.isArray(pagination)) {
    const nested = readTotalCount(pagination as Record<string, unknown>);
    if (nested !== undefined) return nested;
  }
  for (const k of TOTAL_KEYS) {
    const v = o[k];
    if (typeof v === 'number' && Number.isFinite(v)) return v;
    if (typeof v === 'string' && v.trim() !== '') {
      const n = Number(v);
      if (Number.isFinite(n)) return n;
    }
  }
  return undefined;
}

export type GetContactsPayload = {
  contacts: ContactResponse[];
  totalCount?: number;
};

/**
 * תשובת getContacts: מערך גולמי או אובייקט עם רשימה + לעיתים totalCount/total_count.
 */
export function parseGetContactsPayload(raw: unknown): GetContactsPayload | null {
  if (raw == null) return null;

  if (Array.isArray(raw)) {
    return { contacts: raw as ContactResponse[] };
  }

  if (typeof raw === 'object') {
    const o = raw as Record<string, unknown>;
    let totalCount = readTotalCount(o);

    for (const k of ARRAY_KEYS) {
      const v = o[k];
      if (Array.isArray(v)) {
        return { contacts: v as ContactResponse[], totalCount };
      }
    }

    const nested = o.data ?? o.Data;
    if (nested && typeof nested === 'object') {
      const n = nested as Record<string, unknown>;
      if (totalCount === undefined) totalCount = readTotalCount(n);
      for (const k of ARRAY_KEYS) {
        const v = n[k];
        if (Array.isArray(v)) {
          return { contacts: v as ContactResponse[], totalCount };
        }
      }
    }
  }

  return null;
}

/**
 * תשובת getContacts לעיתים מגיעה כמערך גולמי ולעיתים עטופה (data / contacts / …).
 */
export function unwrapGetContactsResponse(raw: unknown): ContactResponse[] | null {
  const p = parseGetContactsPayload(raw);
  return p?.contacts ?? null;
}
